import { SOLACE_PRICEING_DATA } from '../actions/getPricingInfoActions';

export let allPriceListInfoSelector =  (state: any) => {
    return state[SOLACE_PRICEING_DATA];
  };